import { Dispatch, RefObject, SetStateAction, useCallback } from 'react';

/** Syncs the input value to the parent's data-value attr and clears any active option states. */
const useHandleSyncValueAndClearActiveStates = ({
  setMenuOpen,
  selectedOptionsRef,
}: {
  selectedOptionsRef: RefObject<HTMLDivElement | null>;
  setMenuOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  return useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const target = e.target;
      if (target instanceof HTMLInputElement && target.parentNode instanceof HTMLElement) {
        target.parentNode.setAttribute('data-value', target.value);
      }
      // remove any active remove option btn
      const activeRemoveOption = selectedOptionsRef.current?.querySelector('[data-remove-option-active="true"]');
      if (activeRemoveOption) {
        activeRemoveOption.setAttribute('data-remove-option-active', 'false');
      }
      // if any active menu option, remove active state
      const activeMenuOption = document.querySelector('[data-menu-list-option-active="true"]');
      if (activeMenuOption) {
        activeMenuOption.setAttribute('data-menu-list-option-active', 'false');
      }
      setMenuOpen(true);
    },
    [selectedOptionsRef, setMenuOpen]
  );
};

export default useHandleSyncValueAndClearActiveStates;
